import {repository} from '@petrhythm/data';
import type { FileSaveResult, PlatformAdapter } from '@petrhythm/core';
export async function saveProductFile(platform: PlatformAdapter, filename: string, blob: Blob): Promise<FileSaveResult> {
  const result=platform.files?await platform.files.save(filename,blob):{status:'unavailable' as const,message:'이 환경에서 파일 저장을 확인할 수 없어요.'};
  if((result.status==='saved'||result.status==='requested')&&/^petrhythm-(?:\d{4}-\d{2}-\d{2}|backup|move)\.(?:json|csv)$/.test(filename)){try{await repository.setSetting('last-file-export',Date.now());}catch{/* 파일 응답은 유지하고 다음 안내에서 백업 시각을 다시 확인한다. */}}
  return result;
}
export const fileSaveMessage = (result: FileSaveResult) => result.status === 'saved' ? '기기의 파일 저장 완료 응답을 확인했어요.' : result.status === 'requested' ? '다운로드를 요청했어요. 브라우저의 다운로드 목록을 확인해 주세요.' : result.status === 'cancelled' ? '파일 저장을 취소했어요. 기록은 그대로예요.' : result.message ?? '파일을 저장하지 못했어요. 기록은 그대로예요.';

/** A denied share/clipboard must still deliver the actual file, never just its description. */
export async function shareProductFile(platform: PlatformAdapter, filename: string, blob: Blob, details: { title: string; text: string }): Promise<string> {
  let copied = false;
  try {
    const result = await platform.share.share({ ...details, files: [new File([blob], filename, { type: blob.type })] });
    if (result !== 'copied') return '공유 화면에 PDF를 전달했어요. 발송 여부를 확인해 주세요.';
    copied = true;
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') return '공유를 취소했어요. 기록은 그대로예요.';
  }
  try {
    const saved = await saveProductFile(platform, filename, blob);
    return copied ? `${fileSaveMessage(saved)} 전달 문구는 복사했어요.` : `공유하지 못해 PDF를 파일로 저장해요. ${fileSaveMessage(saved)}`;
  } catch {
    return '공유와 파일 저장을 완료하지 못했어요. 기록은 그대로예요. PDF로 저장 버튼으로 다시 시도해 주세요.';
  }
}
